const normalizeForMatch = (str: string): string =>
  str.toLowerCase().replace(/[\s\-_.]+/g, '');

export const isCompetitorDomain = (
  domain: string,
  competitorKeywords: { normalizedKeyword: string }[],
  competition: { name: string; domain?: string }[]
): boolean => {
  const domainLower = domain.toLowerCase();
  const domainRoot = normalizeForMatch(domain.split('.')[0]);

  // 1. Explicit domain mapping from competition (manual override — highest priority)
  if (competition.some((c) => c.domain && domainLower === c.domain.toLowerCase())) {
    return true;
  }

  // 2. Match against monitor_keywords (primary source)
  if (
    competitorKeywords.some((k) => {
      const keyNorm = normalizeForMatch(k.normalizedKeyword);
      return domainRoot === keyNorm || domainRoot.includes(keyNorm);
    })
  ) {
    return true;
  }

  // 3. Heuristic from competition names (fallback)
  return competition.some((c) => {
    if (c.domain) return false;
    const nameNorm = normalizeForMatch(c.name);
    return domainRoot === nameNorm || domainRoot.includes(nameNorm);
  });
};
